import { signInAuthProvider, getLoginRequest } from 'auth';
import { get } from 'lodash';
import { APPLICATION_NAMESPACE, APPLICATION_ID } from './authConstants';
import { getSigninPolicyName } from './msalReactAuthProvider';

async function getAccessToken() {
  // multiple policies is possible to create multiple accounts here, e.g.
  // 1. When user login with signin policy, one account is enqueued with Access Token(AT) and Refress Toke(RT)
  // 2. When user try to edit profile with edit policy, one new account is enqueued,
  // 3. When edit password, another account will be enqueued.
  // the backend API is using signin policy to decode the JWT code,
  // so it's important to find the correct account when accessing its AT and RT
  const accounts = signInAuthProvider.getAllAccounts();
  console.log('accounts', accounts);
  if (accounts.length > 0) {
    const signinPolicyName = getSigninPolicyName();

    const signinPolicyAccount = accounts.find((a) => {
      return get(a.idTokenClaims, 'acr') === signinPolicyName;
    });

    const request = {
      scopes: [`https://${APPLICATION_NAMESPACE}.onmicrosoft.com/${APPLICATION_ID}/User.Read`],
      account: signinPolicyAccount ?? accounts[accounts.length - 1],
    };
    try {
      const accessToken = await signInAuthProvider.acquireTokenSilent(request);
      console.log('request', request);

      return accessToken;
    } catch (error: unknown) {
      // Do not fallback to interaction when running outside the context of MsalProvider. Interaction should always be done inside context.
      console.log(error);
      // InteractionRequiredAuthError: interaction_required: AADB2C90077: User does not have an existing session and request prompt parameter has a value of 'None'
      if ((get(error, 'message') ?? '').indexOf('AADB2C90077') > -1) {
        signInAuthProvider.loginRedirect(getLoginRequest()).catch(console.error);
      }
      return null;
    }
  }

  return null;
}

export default getAccessToken;
